import React, { useState, useMemo } from 'react'
import { DrawerCreditOptions } from '@sainsburys-tech/bolt'
import MonthlyPaymentsTable from '../AFSCredit/components/FinanceDrawer/MonthlyPaymentsTable'
import { getPreferredCreditPlans } from '../../helpers/creditPlanHelper'
import { PAYPAL_PROVIDED } from '../../helpers/FinanceProviderConstants'

import * as Styled from './PriceDynamicCreditCopy.styles'

const PriceDynamicCreditCopy = ({ creditPlans, ShowPaypalCreditOption }) => {
  const [showDrawer, setShowDrawer] = useState(false)

  const toggleDrawer = show => {
    setShowDrawer(show)
  }

  const { qualifyingCreditPlans, availableProviders } = useMemo(() => {
    if (!creditPlans) return { qualifyingCreditPlans: [], availableProviders: [] }
    return getPreferredCreditPlans(creditPlans)
  }, [creditPlans])

  const bestPlan = qualifyingCreditPlans[0] || null
  const financeMessage = bestPlan
    ? `From £${bestPlan.periodicPayment?.toFixed(2)} per month at ${bestPlan.apr}% interest over ${
        bestPlan.periodDuration
      } months `
    : ''

  return (
    <>
      {ShowPaypalCreditOption && availableProviders.includes(PAYPAL_PROVIDED) ? (
        <>
          <Styled.TextContainer data-test='text-container'>
            {financeMessage}
            {bestPlan && (
              <Styled.Link data-test='learn-more-link' onClick={() => toggleDrawer(true)}>
                Learn more
              </Styled.Link>
            )}
          </Styled.TextContainer>

          <DrawerCreditOptions
            monthlyPaymentsTable={<MonthlyPaymentsTable plans={qualifyingCreditPlans} />}
            show={showDrawer}
            onClose={() => toggleDrawer(false)}
          />
        </>
      ) : null}
    </>
  )
}

export default PriceDynamicCreditCopy
